import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})

export class LoggedInGaurd {

  constructor(private route: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const role = this.authService.getRole();
    if (!role || role === 'guest' || role === 'Pending') {
      return true;
    }
    
    // Explicitly navigate to the correct dashboard to avoid loops at the root "" redirect
    if (role === 'Utility') {
        this.route.navigate(['/homepage']);
    } else if (role === 'IntegrationPartner') {
        this.route.navigate(['/partner-dashboard']);
    } else if (role === 'Consumer' || role === 'Prosumer') {
        this.route.navigate(['/market']);
    } else if (role === 'SuperAdmin') {
        this.route.navigate(['/admin-dash/dashboard']);
    } else {
        this.route.navigate(['/']); // Fallback if no specific dashboard
    }
    return false;
  }
}
